import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { selectHelpers } from '../core/store/helpers/selector/helpers.selectors';
import { Store } from '@ngrx/store';
import { selectSidebar } from '../core/store/animation/selector/animation.selectors';
import { appState } from '..';
import { LadeskChatService } from '../core/services/ladeskChat/ladesk-chat.service';
import { RouterOutlet } from '@angular/router';
import { GlobalNotificationComponent } from '../shared/toaster/global-notification/global-notification.component';
import { FooterComponent } from '../shared/main/footer/footer.component';
import { NgIf, NgOptimizedImage } from '@angular/common';
import { HeaderComponent } from '../shared/header/header/header.component';
import { SideNavComponent } from '../shared/side-nav/side-nav.component';
import { getRouterSelectors } from '@ngrx/router-store';
import { TranslocoModule } from '@ngneat/transloco';
import { ParticlesBackgroundComponent } from '../shared/animations/particles-background/particles-background.component';
import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import { ScrollToTopService } from '../core/services/scrollToTop/scroll-to-top.service';
import { LocalStorageService } from '../core/services/localStorage/local-storage.service';
import { selectUser } from '../core/store/user/selectors/user.selector';
import { ModalsActions } from '../core/store/modals/actions/modals.actions';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { selectConfig } from '../core/store/config/selector/config.selectors';

const easeInOutBtns = trigger('btnTrigger', [
  transition(':enter', [
    animate(
      `500ms`,
      keyframes([
        style({
          opacity: 0,
          right: '-200px',
        }),
        style({
          opacity: 0.5,
          right: '0',
        }),
      ])
    ),
  ]),
  transition(':leave', [
    animate(
      `300ms`,
      keyframes([
        style({
          opacity: 0.5,
          right: '0',
        }),
        style({
          opacity: 0,
          right: '-200px',
        }),
      ])
    ),
  ]),
]);
@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  standalone: true,
  animations: [easeInOutBtns],
  imports: [
    SideNavComponent,
    HeaderComponent,
    RouterOutlet,
    FooterComponent,
    ParticlesBackgroundComponent,
    NgIf,
    NgOptimizedImage,
    GlobalNotificationComponent,
    TranslocoModule,
  ],
})
export class PagesComponent implements OnInit, OnDestroy {
  unsubus$: Subject<boolean> = new Subject();
  config$: Observable<any> = this.store.select(selectConfig);
  categoryBarStateDestroy$: Subject<boolean> = new Subject();
  helpers$: Observable<any> = this.store.select(selectHelpers);
  sitebar$: Observable<any> = this.store.select(selectSidebar);
  user$: Observable<any> = this.store.select(selectUser);
  delay: ReturnType<typeof setTimeout> = setTimeout(() => {});
  isNotFoundPage: boolean = false;
  videoUrl: SafeResourceUrl = '';
  userRestricted: boolean = false;

  slug: string = '';
  isMobile: boolean = true;
  isAuth: boolean = false;
  isHiddenBar: boolean = false;
  showBackTop: boolean = false;
  isSportBook: boolean = false;
  isActiveGame: boolean = false;
  extraPadding: boolean = false;
  isLoyaltyPage: boolean = false;
  isAcordionOpen: boolean = false;
  isHovering: boolean = false;
  isLoaded: boolean = false;
  Router$: Observable<any> = this.store.select(getRouterSelectors().selectUrl);
  currentScrollY: number = 0;
  playBubbleAnime: boolean = true;
  @HostListener('window:scroll', ['$event'])
  onScroll() {
    const fromTop = document.getElementById('staticHeader')?.getBoundingClientRect().top;
    clearTimeout(this.delay);
    this.delay = setTimeout(() => {
      this.currentScrollY = window.scrollY;
      if (this.currentScrollY > 240 && !this.showBackTop) {
        this.showBackTop = true;
      }
      if (this.currentScrollY < 240 && this.showBackTop) {
        this.showBackTop = false;
      }
      if (fromTop) this.isHiddenBar = fromTop < 50;
    }, 10);
  }
  constructor(
    private store: Store<appState>,
    private liveChat: LadeskChatService,
    private scroll: ScrollToTopService,
    private storageService: LocalStorageService,
    private sanitazer: DomSanitizer
  ) {}

  ngOnInit(): void {
    const bubbleAnimStoredValue = this.storageService.getLocalStorage('playBubbleAnim');
    if (bubbleAnimStoredValue !== null) {
      this.playBubbleAnime === JSON.parse(bubbleAnimStoredValue);
    }
    this.Router$.pipe(takeUntil(this.unsubus$)).subscribe((res: any) => {
      setTimeout(() => {
        const isAsideVisible = res.includes('aside') && this.isHiddenBar;

        const categoryBarData = isAsideVisible
          ? {
              data: !isAsideVisible,
            }
          : {
              data:
                (res.includes('games') && !res.includes('aside')) ||
                (res.includes('providers') && !res.includes('aside')) ||
                (res === '/' && window.scrollY !== 0),
            };
        this.isHiddenBar = categoryBarData.data;
      }, 100);
      // this.isLoyaltyPage = res.includes('/loyalty');
      // if (this.isLoyaltyPage) {
      //   if (
      //     this.storageService.getLocalStorage('loyaltyVideo') === 'false' ||
      //     this.storageService.getSessionStorage('loyaltyVideo') === 'false'
      //   ) {
      //     this.isAcordionOpen = false;
      //   } else {
      //     this.isAcordionOpen = true;
      //   }
      // }

      this.isSportBook = res.includes('1477472');
      this.isActiveGame = res.includes('/game/');
      this.extraPadding = res.includes('games');
      this.isNotFoundPage = res.includes('page-not-found') ? true : false;
    });
    this.helpers$.pipe(takeUntil(this.unsubus$)).subscribe((res) => {
      if (res.isLoaded) {
        this.isMobile = res.isMobile;
      }
    });
    this.user$.pipe(takeUntil(this.unsubus$)).subscribe((res: any) => {
      this.isAuth = res.isAuth;
    });
    this.config$.pipe(takeUntil(this.unsubus$)).subscribe((res: any) => {
      if (res?.isLoaded) {
        if (res?.config?.status !== 451) {
          this.userRestricted = false;
        } else {
          this.userRestricted = true;
        }
      }
    });
    // setTimeout(() => {
    //   this.setInitialVideoState();
    // }, 500);
  }
  openLiveChat() {
    this.liveChat.openLiveAgent({ type: 'liveChat' });
  }
  setInitialVideoState() {
    // if (
    //   (this.isAuth && this.storageService.getLocalStorage('loyaltyVideo') === 'false') ||
    //   this.storageService.getSessionStorage('loyaltyVideo') === 'false'
    // ) {
    //   this.isAcordionOpen = false;
    // } else {
    //   this.isAcordionOpen = true;
    // }
    // this.updateVideo();
  }
  ngOnDestroy(): void {
    this.unsubus$.next(true);
    this.unsubus$.complete();
  }
  navigateTop() {
    this.scroll.scrollToTop();
  }
  // toggleAccordion() {
  //   if (
  //     this.isAuth &&
  //     this.isAcordionOpen &&
  //     (!this.storageService.getLocalStorage('loyaltyVideo') ||
  //       this.storageService.getLocalStorage('loyaltyVideo') !== 'false')
  //   ) {
  //     this.store.dispatch(
  //       ToasterActions['[toaster]SetToasterMessgageSuccess']({
  //         data: {
  //           place: 'loyalty_settings',
  //           type: 'info',
  //         },
  //       })
  //     );
  //   }
  //   this.storageService.setSessionStorage('loyaltyVideo', 'false');
  //   this.isAcordionOpen = !this.isAcordionOpen;
  //   this.isHovering = false;
  //   this.updateVideo();
  // }
  // updateVideo() {
  //   if (this.isAcordionOpen) {
  //     const url =
  //       'https://customer-f510plc3941a75sb.cloudflarestream.com/41b00c9ed147ffd9fce350289643013e/iframe?muted=true&preload=true&autoplay=true&poster=https%3A%2F%2Fcustomer-f510plc3941a75sb.cloudflarestream.com%2F41b00c9ed147ffd9fce350289643013e%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600&controls=true';
  //     this.videoUrl = this.sanitazer.bypassSecurityTrustResourceUrl(url);
  //     this.isLoaded = true;
  //   } else {
  //     const url =
  //       'https://customer-f510plc3941a75sb.cloudflarestream.com/41b00c9ed147ffd9fce350289643013e/iframe?preload=true&poster=https%3A%2F%2Fcustomer-f510plc3941a75sb.cloudflarestream.com%2F41b00c9ed147ffd9fce350289643013e%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600&controls=true';
  //     this.videoUrl = this.sanitazer.bypassSecurityTrustResourceUrl(url);
  //   }
  // }
  openModal() {
    this.store.dispatch(
      ModalsActions['[modals]OpenModalSuccess']({
        id: 'loyaltyVideo',
      })
    );
  }
}
